'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = translateProps;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _intlMethods = require('./intlMethods');

var _intlMethods2 = _interopRequireDefault(_intlMethods);

var identity = function identity(v) {
  return v;
};

// a decorator to translate t.ReactNode "translatable" props
// translatable meaning: is a string and has the form of a translation key
// optional `keyMap` and `keyExists` fns: see `@intlMethods`

function translateProps(keyMap, keyExists) {

  return function (Component) {
    var Wrapper = (function (_React$Component) {
      function Wrapper() {
        _classCallCheck(this, _Wrapper);

        if (_React$Component != null) {
          _React$Component.apply(this, arguments);
        }
      }

      _inherits(Wrapper, _React$Component);

      var _Wrapper = Wrapper;

      _Wrapper.prototype.translatedProps = function translatedProps() {
        var _this = this;

        return Object.keys(this.props).reduce(function (ac, k) {
          var _extends2;

          return _extends({}, ac, (_extends2 = {}, _extends2[k] = typeof _this.props[k] === 'string' ? _this.formatMessageIfItExists(_this.props[k]) : _this.props[k], _extends2));
        }, {});
      };

      _Wrapper.prototype.render = function render() {
        return _react2['default'].createElement(Component, this.translatedProps());
      };

      Wrapper = (0, _intlMethods2['default'])(keyMap, keyExists)(Wrapper) || Wrapper;
      return Wrapper;
    })(_react2['default'].Component);

    return Wrapper;
  };
}

module.exports = exports['default'];


// WEBPACK FOOTER //
// ./~/react-intl-hoc/lib/translateProps.js